/* RESPONSIBLE TEAM: team-knowledge-foundations */
export default class TitleFilter {
  static type = 'title';
  static icon = 'text-block';
  static labelKey = 'articles.list.search.title-contains';

  static create({ value }: { value: string }) {
    return new TitleFilter(value);
  }

  type = TitleFilter.type;
  icon = TitleFilter.icon;
  labelKey = TitleFilter.labelKey;

  value: string;

  constructor(value: string) {
    this.value = value;
  }

  get text() {
    return this.value;
  }
}
